import { Button, Modal, Space } from "antd";
import React from "react";

const CustomModal = ({
  title,
  open,
  width = 400,
  onOk,
  onCancel,
  disabled,
  children,
  footer,
  centered = false,
}) => {
  return (
    <Modal
      title={title ?? ""}
      closable={{ "aria-label": "Custom Close Button" }}
      width={width}
      open={open}
      // onOk={onOk}
      onCancel={onCancel}
      centered={centered}
      footer={
        footer === null
          ? null
          : footer || [
              // <Space>

              <Button
                key={"cancel"}
                color="default"
                variant="filled"
                style={{ height: "40px", padding: "0 20px" }}
                onClick={onCancel}
              >
                Болих
              </Button>,
              <Button
                key={"done"}
                type="primary"
                style={{ height: "40px", padding: "0 20px" }}
                onClick={onOk}
                disabled={disabled}
              >
                Хадгалах
              </Button>,
              // </Space>
            ]
      }
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
